import Model, { hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BulkAirbnbPriceSyncModel extends Model {
  @hasMany('property', { inverse: null, async: false })
  properties!: ModelRegistry['property'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-airbnb-price-sync': BulkAirbnbPriceSyncModel;
  }
}
